import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Importing components
import { CurrentChapterIndicator } from '../chapters/current-chapter-indicator';
// Importing hooks
import { useDuration } from '../../../hooks/use-duration';
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { usePlayerStore } from '../../../store/player.store';
// Importing types
import { MediaChapterType } from '../../../types/media';
// Importing 3rd party components
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ----------------------------------------------------------------------
export const DurationsControls = () => {
    // Adding hooks
    const { formatDuration } = useDuration();
    // Adding data handler
    const { chapter, duration, played } = usePlayerStore(useShallow((state) => ({
        chapter: state.chapter,
        duration: state.duration,
        played: state.played,
    })));
    // Resolving type issues from chapter type input
    const chapterType = chapter
        ? MediaChapterType[chapter.type]
        : undefined;
    return (_jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: 'center' }, children: [_jsxs(Typography, { color: "white", variant: "caption", children: [formatDuration(duration * played), " / ", formatDuration(duration)] }), chapter && (_jsx(CurrentChapterIndicator, { chapter: chapter, clickable: true, separator: true }))] }));
};
